import React from 'react'

import { Card } from 'antd'

import { ComponentsMenu } from '../ComponentsMenu'
import { CustomFieldsList } from '../CustomFieldsList'
import { FieldProperties } from '../FieldProperties'
import { CustomFieldsProvider } from '../../context/customFields'

import './styles.less'

export function ActionCustomFields() {
  return (
    <CustomFieldsProvider>
      <Card className="ant-card gx-card ant-card-bordered actionTypeCustomFields">
        <div className="actionTypeCustomFields__content">
          <div className="actionTypeCustomFields__componentsMenu">
            <ComponentsMenu />
          </div>

          <div className="actionTypeCustomFields__fieldsList">
            <CustomFieldsList />
          </div>

          <div className="actionTypeCustomFields__fieldForm">
            <FieldProperties />
          </div>
        </div>
      </Card>
    </CustomFieldsProvider>
  )
}
